import { render } from "./PreferredSkills.vue?vue&type=template&id=2b095c96&ts=true"
import script from "./PreferredSkills.vue?vue&type=script&lang=ts"
export * from "./PreferredSkills.vue?vue&type=script&lang=ts"

import "./PreferredSkills.vue?vue&type=style&index=0&id=2b095c96&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__